import React from 'react';
import { FormBlock } from '../../types/general';
import * as Schema from '../../types/schema';
import { DefaultBlockWrapper, PropsDriller } from './Form';

function Component(props: FormBlock<Schema.Component>) {
	const { schema, components, options = {} } = props;
	const { BlockWrapper = DefaultBlockWrapper, editMode } = options;
	const { id, name } = schema;
	const drill = PropsDriller(props);

	return (
		<BlockWrapper
			id={id}
			type='component'
			schema={schema}
			onPlaceHolder={() => {
				/* */
			}}
		>
			<div id={id} key={id} className='Component'>
				{editMode && <div>{name}</div>}
				{!editMode && components && components[schema.name]
					? components[schema.name]({ ...schema.props, ...drill })
					: null}
			</div>
		</BlockWrapper>
	);
}

export default Component;
